import { useEffect, useRef } from 'react';

export default function HeroSection() {
  const titleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = titleRef.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    const timer = setTimeout(() => {
      el.style.transition = 'opacity 0.9s ease, transform 0.9s ease';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  const handleScroll = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9308855d8ef2c632bd75993414fe73f6.jpg"
          alt="산업기계설비 제조 현장"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-black/10" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/25" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 pt-24 pb-20">
        <div ref={titleRef} className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 mb-8">
            <span className="w-8 h-px bg-[#E8C27A]" />
            <span className="text-[#E8C27A] text-sm font-medium tracking-widest uppercase">
              Since 2000 · 산업기계설비 전문
            </span>
          </div>

          {/* Main Title */}
          <h1 className="text-6xl lg:text-7xl xl:text-8xl font-black text-white leading-tight mb-6">
            <span className="block font-light text-5xl lg:text-6xl mb-2">산업기계설비 및</span>
            <span className="block">도장설비</span>
            <span className="block text-[#E8C27A]">제조 전문기업</span>
          </h1>

          {/* Sub Text */}
          <p className="text-lg text-white/80 leading-relaxed max-w-xl mb-10">
            (주)에스제이엔지니어링은 2000년 창업 이래 25년 이상의 기술력과 풍부한 경험으로<br />
            고객 맞춤형 최고의 산업설비 솔루션을 제공합니다.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => handleScroll('products')}
              className="flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#C0392B] text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-[#A93226] transition-all duration-200"
            >
              <i className="ri-briefcase-4-line" />
              제품 및 서비스 보기
              <i className="ri-arrow-right-line" />
            </button>
            <button
              onClick={() => handleScroll('contact')}
              className="flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/60 text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-white/10 transition-all duration-200"
            >
              <i className="ri-phone-line" />
              견적 문의하기
            </button>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="absolute bottom-12 right-6 lg:right-12 flex gap-10">
          {[
            { num: '30+', label: '년 업력' },
            { num: '500+', label: '납품 실적' },
            { num: '100%', label: '고객 만족' },
          ].map((stat) => (
            <div key={stat.label} className="text-right">
              <p className="text-4xl font-black text-[#E8C27A] leading-none">{stat.num}</p>
              <p className="text-xs text-white/60 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 text-xs tracking-widest">SCROLL</span>
        <i className="ri-arrow-down-line text-white/40" />
      </div>
    </section>
  );
}
